"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _cnbuilder = require("cnbuilder");
var _dist = require("react-day-picker/dist");
var _reactI18next = require("react-i18next");
var _arrowLeftDefault = _interopRequireDefault(require("@teladoc/pulse/icons/arrow-left-default.svg"));
var _arrowRightDefault = _interopRequireDefault(require("@teladoc/pulse/icons/arrow-right-default.svg"));
var _DateTime = require("../Context/l10n/DateTime");
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _ArrowNavigationModule = _interopRequireDefault(require("./ArrowNavigation.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const ArrowNavigation = _ref => {
  let {
    date
  } = _ref;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    format
  } = (0, _DateTime.useL10nDateTimeContext)();
  const {
    classNameTitle,
    classNamePrevious,
    classNameNext,
    testAttrPrevious,
    testAttrNext,
    testAttrTitle,
    i18nPreviousLabel,
    i18nNextLabel,
    disableNavigation,
    id
  } = (0, _dist.useDayPicker)();
  const {
    goToMonth,
    previousMonth,
    nextMonth
  } = (0, _dist.useNavigation)();
  const onPreviousClick = () => {
    goToMonth(previousMonth);
  };
  const onNextClick = () => {
    goToMonth(nextMonth);
  };
  const onKeydownPreviousBtn = e => {
    // if Shift-TAB key pressed should focusing on the Close button
    if (e.shiftKey && e.keyCode === 9) {
      const closeCalBtn = document.querySelector('button[data-trap="calendarCloseBtn"]');
      e.preventDefault();
      if (closeCalBtn) {
        closeCalBtn.focus();
      }
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
      className: (0, _cnbuilder.cnb)(_ArrowNavigationModule.default.previous, classNamePrevious),
      testAttr: testAttrPrevious,
      i18nLabel: i18nPreviousLabel || t('ui:calendar.previous'),
      disabled: disableNavigation || !previousMonth,
      "data-trap": "prevMonthArrowBtn",
      onClick: onPreviousClick,
      onKeyDown: onKeydownPreviousBtn,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_arrowLeftDefault.default, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", _objectSpread(_objectSpread({}, id && {
      id: "".concat(id, "-heading")
    }), {}, {
      className: (0, _cnbuilder.cnb)(_ArrowNavigationModule.default.title, classNameTitle),
      "data-test": testAttrTitle,
      "aria-live": "polite",
      "aria-atomic": "true",
      children: format(date, 'MMMM yyyy')
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
      className: (0, _cnbuilder.cnb)(_ArrowNavigationModule.default.next, classNameNext),
      testAttr: testAttrNext,
      i18nLabel: i18nNextLabel || t('ui:calendar.next'),
      disabled: disableNavigation || !nextMonth,
      "data-trap": "nextMonthArrowBtn",
      onClick: onNextClick,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_arrowRightDefault.default, {})
    })]
  });
};
var _default = exports.default = ArrowNavigation;